import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const Roles = lazy(() => import('../../pages/Roles/RolesPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<Roles />} />
    </Routes>
  );
}

export default PagesRoute;
